// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedditCircleFilledSvg from "@fishx/icons-svg/es/asn/RedditCircleFilled";
import FishxIcon from '../components/FishxIcon';

var RedditCircleFilled = function RedditCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedditCircleFilledSvg
  }));
};

RedditCircleFilled.displayName = 'RedditCircleFilled';
export default React.forwardRef(RedditCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedditCircleFilled.js
// module id = 3983
// module chunks = 0